import React from 'react';
import { NavLink } from 'react-router-dom';
import { CATALOGUE_PATH, COUNTS_PATH, LEDGER_PATH, LOCATIONS_PATH } from '../utils/siteDrillThrough';

const LINKS = [
  { to: LOCATIONS_PATH, label: 'Sites', end: true },
  // Not `end`: a count sheet (/locations/counts/:id) keeps the Counts tab lit.
  { to: COUNTS_PATH, label: 'Counts', end: false },
  { to: LEDGER_PATH, label: 'Ledger', end: true },
  { to: CATALOGUE_PATH, label: 'Catalogue', end: true },
];

/** The materials sections, laid out like EquipmentSubnav. */
const MaterialsSubnav: React.FC = () => (
  <nav aria-label="Materials sections" className="tw-mb-4 tw-flex tw-flex-wrap tw-gap-1 tw-border-b tw-border-line">
    {LINKS.map((link) => (
      <NavLink
        key={link.to}
        to={link.to}
        end={link.end}
        className={({ isActive }) =>
          `-tw-mb-px tw-border-b-2 tw-px-3 tw-py-2 tw-text-sm tw-no-underline ${
            isActive
              ? 'tw-border-primary tw-font-medium tw-text-primary'
              : 'tw-border-transparent tw-text-content-secondary hover:tw-text-content'
          }`
        }
      >
        {link.label}
      </NavLink>
    ))}
  </nav>
);

export default MaterialsSubnav;
